export class RegulationCheckboxViewModel {
    Id: number;
    IsApplicable: boolean;
    IsRead: boolean;
    IsOperative: boolean;
    ownerList:string;
    constructor() {
      this.Id =  0;
      this.IsApplicable =  false;
      this.IsRead =  false;
      this.IsOperative =  false;
      this.ownerList = '';
    }
  }

  export class RegulationCheckboxReturnModel{
    id:number;
    value:boolean;
    constructor(){
        this.id = 0;
        this.value = false;
    }
  }